import L from 'leaflet';

/**
 * Kartverket WMTS topo (web mercator). Official Leaflet URL uses {z}/{y}/{x}.
 */
export function createKartverketTopoLayer() {
  return L.tileLayer(
    'https://cache.kartverket.no/v1/wmts/1.0.0/topo/default/webmercator/{z}/{y}/{x}.png',
    {
      attribution: '&copy; <a href="https://www.kartverket.no">Kartverket</a>',
      maxZoom: 18
    }
  );
}
